import {db} from "../../../Firebase";
import * as firebase from "firebase";
import {SHOW_SNACKBAR} from "../../type";


/**
 * This function will add a like for a recipe, value is +1 or -1, if the current user already have add a like,
 * the old one will be overwritten
 * @param values    {object}: contains recipe's name, user's pseudo and the like value
 */
export const addLike = ( values ) => async dispatch => {
    try {
        let id = "";
        let ancientLike = null;
        await db.collection("recipes").where("name", "==", values.recipeName).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                id = doc.id;

                //if this recipe have already some likes, we search if the current user already add one
                if(doc.data().likes){
                    ancientLike = doc.data().likes.find(element => element.user === values.userPseudo);
                }
            });
        });

        let recipeRef = db.collection("recipes").doc(id);
        if (ancientLike) {  //if the current user already add a like for this recipe, we remove the old one
            await recipeRef.update({likes: firebase.firestore.FieldValue.arrayRemove(ancientLike)});
        }

        await recipeRef.update({likes: firebase.firestore.FieldValue.arrayUnion({value:values.value, user:values.userPseudo})});
        dispatch({type: SHOW_SNACKBAR, payload: {txt: (values.value===1 ? 'vous avez liké ' : "vous avez disliké ") + values.recipeName, variant: "success"}});
    }
    catch(e){
        dispatch({type: SHOW_SNACKBAR, payload: {txt: "une erreur est survenue lors de l'ajout de votre " + (values.value===1 ? 'like' : "dislike"), variant: "error"}});
    }
};


